import axios from "axios";
export const CommentNews = async (appNewsId, text, name) => {
  const token = JSON.parse(localStorage.getItem("authentication"));
  const config = {
    headers: { Authorization: `Bearer ${token}` },
  };
  try {
    const { data } = await axios.post(
      `${process.env.REACT_APP_BACKEND_API}/api/news/CommentNews`,
      { appNewsId, text, name },
      config
    );
    return { status: 200, data };
  } catch (error) {
    console.error("CommentNews error:", error);
    return { status: error?.response?.status || 500, data: null };
  }
};
